import request from '@/utils/request'
import { getUserInfo as getUserInfo4LocalSession } from '@/utils/auth'
import URL from './urlTranslator'

export function loginByUsername(data) {
  // return Promise.resolve({ content: 'myToken' })
  return request({
    url: URL.authLogin,
    // url: 'http://39.100.57.32:5000/api/cargoone-auth/login',
    method: 'post',
    data
  })
}

export function loginInitRedisInfo() {
  return request({
    url: URL.sys.loginInitRedisInfo,
    // url: 'http://39.100.57.32:5000/api/cargoone-sys/login',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: URL.sys.logout,
    method: 'get'
  })
}

export function getUserInfo() {
  return new Promise((resolve, reject) => {
    const roles = getUserInfo4LocalSession().privilegeCodeList || []
    resolve({ content: roles })
  })
  // return request({
  //   url: URL.authAuth,
  //   method: 'get'
  // })
}

